<template>

    <div class="forecast">
        <i18n path="closed.availability" tag="div">
            <template v-slot:amount>
                <b style="border-bottom: 4px solid #FFF;">{{ amountOfPeople }}</b>
            </template>
            <template v-slot:time>
                <b style="border-bottom: 4px solid #FFF;">{{ timeInMinutes }}</b>
            </template>
        </i18n>
    </div>

</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Forecast',
    computed: {
      forecasts() {
        return this.$store.getters['forecasts'];
      },

      amountOfPeople() {
        return this.forecasts[0] ? this.forecasts[0].leavers : 0;
      },

      timeInMinutes() {
        let time = 5;
        if (this.forecasts[0]) {
          const from = moment(this.forecasts[0].from);
          const to = moment(this.forecasts[0].to);
          time = to.diff(from, 'minutes');
        }
        return time;
      }
    },
  };
</script>

<style scoped>
    .forecast {
        margin: 0;
        font-size: 2.25em;
        display: block;
    }
</style>